<template>
  <v-container
    style="max-width: 8in; background-color: transparent"
    class="ml-0"
    id="to_hit_cards_id"
    ref="easyPrint"
  >
    <div v-if="pages.length > 0" style="max-width: 8in">
      <div class="page ml-0" v-for="(pg, index1) in pages" :key="index1">
        {{ index1 }}
        <v-container>
          <v-row
            align-items:
            start
            style="width: 100%; height: 3.1in"
            class="justify-space-around"
            v-for="(row, index2) in rows"
            :key="index2"
          >
            <v-col
              class="dc_container"
              v-for="(col, index3) in cols"
              :key="index3"
            >
              <div
                class="dicecard d-flex flex-column justify-center align-center mt2"
              >
                <small>Beta FX&copy;</small>
                <small class="mb-4">Every Di Dicecard</small>

                <p style="font-size: 18px; font-weight: 800">
                  <span>3d6:</span>
                  <span
                    style=""
                    :class="[
                      all_everydi[index1 * 9 + index2 * 3 + index3 + 1].a3d6 ==
                        18 ||
                      all_everydi[index1 * 9 + index2 * 3 + index3 + 1].a3d6 ==
                        3
                        ? rr.toString()
                        : '',
                    ]"
                  >
                    {{ all_everydi[index1 * 9 + index2 * 3 + index3 + 1].a3d6 }}
                  </span>
                  <span class="ml-2">d100:</span>
                  <span style="">
                    {{ all_everydi[index1 * 9 + index2 * 3 + index3 + 1].pnt }}
                  </span>
                </p>
                <p style="font-size: 18px; font-weight: 800">
                  <span>d4:</span>
                  <span style="">
                    {{ all_everydi[index1 * 9 + index2 * 3 + index3 + 1].d4 }}
                  </span>
                  <span class="ml-2">d6:</span>
                  <span style="">
                    {{ all_everydi[index1 * 9 + index2 * 3 + index3 + 1].d6 }}
                  </span>
                </p>
                <p style="font-size: 18px; font-weight: 800">
                  <span>d8:</span>
                  <span style="">
                    {{ all_everydi[index1 * 9 + index2 * 3 + index3 + 1].d8 }}
                  </span>
                  <span class="ml-2">d12:</span>
                  <span style="">
                    {{ all_everydi[index1 * 9 + index2 * 3 + index3 + 1].d12 }}
                  </span>
                </p>
                <p style="font-size: 18px; font-weight: 800">
                  <span>2d4:</span>
                  <span style="">
                    {{ all_everydi[index1 * 9 + index2 * 3 + index3 + 1].a2d4 }}
                  </span>
                  <span class="ml-2">3d4:</span>
                  <span style="">
                    {{ all_everydi[index1 * 9 + index2 * 3 + index3 + 1].a3d4 }}
                  </span>
                </p>
                <p style="font-size: 18px; font-weight: 800">
                  <span class="ml-2">d20:</span>
                  <span style="">
                    {{ all_everydi[index1 * 9 + index2 * 3 + index3 + 1].d20 }}
                  </span>
                </p>
                <v-spacer></v-spacer>
                <small class="mr-1" style="width: 100%; text-align: right">{{
                  index1 * 9 + index2 * 3 + index3 + 1
                }}</small>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
    <!--//@*/*
    //    *BUS Dice Cars  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
.red {
  color: red;
}
.page {
  width: 8in;
  height: 10in;
  border: 5px solid rgb(92, 145, 206);
  background-color: white !important;
}
.dc_container {
  width: 2in;
  height: 3in;
}
.dicecard {
  width: 2in;
  height: 3in;
  border: 3px solid rgb(0, 0, 0);
  background-color: whitesmoke;
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "everydi",
  mixins: [bus_common],
  props: [],
  data() {
    return {
      rr: "red--text",
      cols: [],
      rows: [],
      all3x3d6Rolls: [],
      everydi: {
        a3d6: 0,
        pnt: 0,
        d4: 0,
        d6: 0,
        d8: 0,
        d12: 0,
        d20: 0,
        a2d4: 0,
        a3d4: 0,
      },
      all_everydi: [],
    };
  },
  computed: {
    pages() {
      //   this.mrbreakpoint("page");
      var page_cnt = [];
      // 10 pages is arbitrary
      for (let i = 0; i < 10; i += 1) {
        page_cnt.push(i);
      }
      //    this.mrbreakpoint(result);
      return page_cnt;
    },
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    get_all_everydi: function () {
      this.all_everydi = [];
      this.roll3d6_total = 0;
      var r = this.$rndx;

      this.aroll = [];

      var lmts = { c18: 0, c3: 0 };
      for (let i = 0; i < 120; i++) {
        var alldi = this.mno(this.everydi);

        var roll1 = r.dice(6, 3);
        var val = 0;
        console.log("roll1.length: ", roll1.length);
        for (var j = 0; j < roll1.length; j++) {
          val = val + roll1[j];
        }
        this.mrbreakpoint("every di");
        val = this.stronger(val, lmts);
        alldi.a3d6 = val;
        alldi.pnt = r.dice(100, 1)[0];
        alldi.d4 = r.dice(4, 1)[0];
        alldi.d6 = r.dice(6, 1)[0];
        alldi.d8 = r.dice(8, 1)[0];
        alldi.d12 = r.dice(12, 1)[0];
        alldi.d20 = r.dice(20, 1)[0];
        let a2d4 = r.dice(4, 2);
        alldi.a2d4 = a2d4[0] + a2d4[1];
        let a3d4 = r.dice(4, 3);
        alldi.a3d4 = a3d4[0] + a3d4[1] + a3d4[2];

        this.roll3d6_total += val;
        this.all_everydi.push(alldi);
        // everydi:{'d3d6':0,'pnt':0,'d4':0,'d8':0,'d12':0,'d20':0,},
      }

      // this.show_tohit = true;
      // this.modal_response_show = true;

      // //all rolls completed
      // this.rspns.unshift(newRspns);
    },
    // roll3d6: function () {
    //   this.all3x3d6Rolls = [];
    //   this.roll3d6_total = 0;
    //   var r = this.$rndx;

    //   this.aroll = [];

    //   var lmts = { c18: 0, c3: 0 };
    //   for (let i = 0; i < 120; i++) {
    //     var a3x = {
    //       tohit: 0,
    //       penatrate: 0,
    //       damage: 0,
    //       count: 0,
    //     };

    //     var roll1 = r.dice(6, 3);
    //     var val = 0;
    //     for (var j = 0; j < roll1.length; j++) {
    //       val = val + roll1[j];
    //     }
    //     val = this.stronger(val, lmts);
    //     a3x.tohit = val;

    //     var roll2 = r.dice(6, 3);
    //     var val = 0;
    //     for (var k = 0; k < roll2.length; k++) {
    //       val = val + roll2[k];
    //     }
    //     val = this.stronger(val, lmts);
    //     a3x.penatrate = val;

    //     var roll3 = r.dice(6, 3);
    //     var val = 0;
    //     for (var l = 0; l < roll3.length; l++) {
    //       val = val + roll3[l];
    //     }
    //     val = this.stronger(val, lmts);
    //     a3x.damage = val;

    //     a3x.count = i + 1;

    //     this.all3x3d6Rolls.push(a3x);

    //     this.roll3d6_total += val;

    //     console.log(this.all3x3d6Rolls[i].tohit);
    //     this.show_tohit = true;
    //   }

    //   // this.modal_response_show = true;

    //   // //all rolls completed
    //   // this.rspns.unshift(newRspns);
    // },
    // all3x3d6Rolls_Each: function () {
    //   this.all3x3d6RollsEach = [];
    //   this.roll3d6_total = 0;
    //   var r = this.$rndx;

    //   this.aroll = [];

    //   var lmts = { c18: 0, c3: 0 };
    //   for (let i = 0; i < 120; i++) {
    //     var a3x = {
    //       tohit: 0,
    //       penatrate: 0,
    //       damage: 0,
    //       count: 0,
    //     };
    //     var eachDi = [];
    //     var roll1 = r.dice(6, 3);
    //     var val = 0;
    //     for (var j = 0; j < roll1.length; j++) {
    //       val = val + roll1[j];
    //     }
    //     val = this.stronger(val, lmts);
    //     a3x.tohit = val;
    //     eachDi.push(val);

    //     var roll2 = r.dice(6, 3);
    //     var val = 0;
    //     for (var k = 0; k < roll2.length; k++) {
    //       val = val + roll2[k];
    //     }
    //     val = this.stronger(val, lmts);
    //     eachDi.push(val);
    //     a3x.penatrate = val;

    //     var roll3 = r.dice(6, 3);
    //     var val = 0;
    //     for (var l = 0; l < roll3.length; l++) {
    //       val = val + roll3[l];
    //     }
    //     val = this.stronger(val, lmts);
    //     eachDi.push(val);
    //     a3x.damage = val;

    //     a3x.count = i + 1;

    //     this.all3x3d6Rolls.push(i, eachDi);

    //     // this.show_tohit = true;
    //   }

    //   // this.modal_response_show = true;

    //   // //all rolls completed
    //   // this.rspns.unshift(newRspns);
    // },
    stronger(v, lmts) {
      if (v == 17 && lmts.c18 < 4) {
        lmts.c18 += 1;
        return 18;
      }
      if (v == 4 && lmts.c3 < 4) {
        lmts.c3 += 1;
        return 3;
      }
      if (v == 18) {
        lmts.c18 += 1;
      }
      if (v == 3) {
        lmts.c3 += 1;
      }
      return v;
    },
    fillArrayInt(array, length) {
      for (let index = 0; index < length; index++) {
        array.push(index);
      }
      return array;
    },
    init() {
      this.show_loader(false);
      this.rows = this.mno(this.fillArrayInt(this.rows, 3));
      this.cols = this.mno(this.fillArrayInt(this.cols, 3));
      this.get_all_everydi();
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
